// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperClaimedToast-cls1_D_N","cls2":"PaperClaimedToast-cls2_FZ1 PaperClaimedToast-cls1_D_N"};